module.exports = __webpack_public_path__ + "static/data_accuracy-10486df81da81c9050d0e13393767f9d.svg";